export enum EPaymentStatus {
  New = 'New',
  Pending = 'Pending',
  Processing = 'Processing',
  PartiallyCompleted = 'PartiallyCompleted',
  Completed = 'Completed',
  Rejected = 'Rejected',
  Expired = 'Expired',
}

export enum ECryptoAddressTagType {
  destination_tag = 'destination_tag',
  memo_id = 'memo_id',
  note = 'note',
  tag = 'tag',
}
